export default "__VITE_ASSET__DjBLi7mq__"